import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FarmPostActivity, PostActivity } from '../models/PostActivity.model';
import { ListableProduction } from '../models/farm/production_per_farm';

@Injectable({ providedIn: 'root' })
export class PostActivityService {
  private apiUrl = `${environment.appRoot}/api/activities`;

  constructor(private http: HttpClient) { }


  // getActivities(): Observable<PostActivity[]> {
  //   return this.http.get<PostActivity[]>(this.apiUrl);
  // }
  getFarmActivities(): Observable<PostActivity[]> {
    return this.http.get<PostActivity[]>(`${this.apiUrl}/getFarmActivities`);
  }
  addActivity(post_activities_id: FarmPostActivity, production_list: Array<ListableProduction>){
    return this.http.post(this.apiUrl, {post_activities_id, production_list});
  }

  deleteActivity(activityId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${activityId}`);
  }
}